<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" normal-width="90vw" width="960px">
    <div @click.stop="stopper">
      <div :class="'map-background map-background--' + SITE_CONFIG.site + ' type--' + params.type" v-html="svg"></div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import API from '@/classes/API';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
      svg: '',
      styleNode: '',
    };
  },
  watch: {
    myStyleProp(val) {
      this.styleNode.textContent = val;
      return this.styleNode.textContent;
    },
  },
  mounted() {
    if (this.params.locationId || !this.SITE_CONFIG.accomodations.show_site) {
      this.loadMap();
    }
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'changeMapLocation',
      'openModal',
      'setFilterLocationId',
      'awaitFilter',
    ]),
    stopper() {
    },
    setLocation(id, isArea) {
      let newId = id;
      if (isArea) {
        newId = `area-${newId}`;
      }
      this.setFilterLocationId(newId);
      this.$emit('change', newId);
      this.awaitFilter();
      this.closeModal();
    },
    loadMap() {
      const $this = this;

      API.get('accommodation-map-kungsberget.svg').then((result) => {
        $this.svg = result;

        $this.$nextTick(() => {
          const selector = '.map-background svg > g > g';
          const gs = document.querySelectorAll(selector);
          const areaId = $this.params.areaId;

          console.log(gs);

          /* eslint-disable */
          [].forEach.call(gs, (g) => {
            g.classList.remove('selected');

            const parts = g.id.split('-');
            if (parts[1] && areaId && parts[1].toString() === areaId.toString()) {
              g.classList.add('selected');
            }

            if ($this.params.type === 'interactive') {
              g.addEventListener('click', (e) => {
                $this.setLocation(parseInt(parts[1]));

                const gs = document.querySelectorAll(selector);
                const areaId = $this.params.areaId;

                [].forEach.call(gs, (g) => {
                  g.classList.remove('selected');
                });
                g.classList.add('selected');
                // $this.closeModal();
              });
            }
          });
        });
      });
    },
    openMap(id) {
      this.params.locationId = id;
      this.loadMap();
    },
  },
  filters: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.col
  float left
  width 50%
  padding-right 50px
  +max-mobile()
    width 100%
    padding-right 0
    padding-bottom 40px
  h2
    .icon
      margin-right 15px
    uppercase()
    font-size: 22px;
  p
    font-size: 13px;
    font-weight: 300;
    line-height 1.15em
    margin-top 15px
    margin-bottom 25px
</style>

<style lang="stylus">
selected()
  fill:#208ca2 !important;
  // opacity:0.6183 !important;
  // stroke:#325E00 !important;
  // stroke-width:2px !important;

.kungsberget .map-background
  width:100% !important
  // width 80vw
  max-width 960px !important
  position:relative !important
  //height 100px
  background-repeat:no-repeat !important
  background-size:100% !important
  overflow hidden !important
  svg
    position absolute !important
    top 0 !important
    left 0 !important
    width 100% !important

  svg > g > rect
    display none !important

  // Base style
  svg > g > g > path
    // opacity:0.604 !important;
    // stroke: #FB9C00 !important;
    // stroke-width:2px !important;
    // fill:#373737 !important;
    transition:all 0.3s ease !important

  // Text style
  svg > g > g > text
    // fill:white !important;
    font-family:Barlow !important
    // font-size:10px !important;
    // font-weight: bold !important;

  // Selected
  svg > g > g.selected > rect,
  &.type--interactive svg > g > g:hover > rect
    selected()

  &.map-background--kungsberget
    background-image: url(https://static.booking.branasgruppen.se/static/img/map-231114/background-kungsberget.jpg) !important
    height 1px !important
    padding-top:65% !important;
    svg
      top 0% !important
.map-background.type--interactive
  svg
    g
      cursor: pointer;

.browser-ie .map-background.map-background--kungsberget
  svg
    top 0%
.browser-ie .map-background.map-background--2006
  svg
    top 0%
.browser-ie .map-background.map-background--2007
  svg
    top 0%
.browser-ie .map-background.map-background--2020
  svg
    top 0%

.type--undefined.map-background svg > switch > g > g > path
  fill: transparent !important;
  stroke: transparent !important;
.type--undefined.map-background svg > switch > g > g.selected > path
  fill: #417505 !important;
  stroke: #325e00 !important;

.map-bt
  margin-bottom: 20px
  text-align: left
  background-color: #f9fcfd!important;
  color: #dark-blue!important;
  padding-right: 20px;
  padding-top: 10px!important
  padding-bottom: 7px!important
  margin-top: 10px
  .icon
    position: relative;
    top: -2px
    margin-right: 5px
  .dowload-icon
    margin-left: 10px

</style>



// WEBPACK FOOTER //
// MapModalkungsberget.vue?2028332e